<ng-template id="ngx-photo-editor-modal" #appPhotoEditorContent let-modal>
    <div [style.backgroundColor]="darkTheme?'#36393F':'#D8D8D8'" class="modal-body" style="padding-bottom: 0">
      <h5 [style.color]="darkTheme?'white':'black'" style="margin-bottom: 16px">{{modalTitle}}</h5>
      <div [style.height]="canvasHeight+'px'" class="ngx-photo-editor-img-container">
        <img #image (load)="onImageLoad(image)" [src]="url" crossorigin id="ngx-photo-editor-image" alt="editor de imagen">
      </div>
    </div>

    <div class="ngx-photo-editor-icons-container">
      <i (click)="crop()" class="fas fa-crop-alt"></i>
      <i (click)="clear()" class="fas fa-times"></i>      
      <i (click)="zoomIn()" class="fas fa-search-plus"></i>
      <i (click)="zoomOut()" class="fas fa-search-minus"></i>
      <i (click)="flipV()" class="fas fa-arrows-alt-v"></i>
      <i (click)="flipH()" class="fas fa-arrows-alt-h"></i>
      <i (click)="rotateLeft()" class="fas fa-undo-alt"></i>
      <i (click)="rotateRight()" class="fas fa-redo-alt"></i>
      <i (click)="reset()" class="fas fa-sync-alt"></i>
      <i (click)="move()" class="fas fa-arrows-alt"></i>
    </div>

    <div [style.backgroundColor]="darkTheme?'#36393F':'#D8D8D8'" class="ngx-photo-editor-custom-modal-footer">
      <button (click)="aspectRat(0);" class="btn btnleft" type="button">Libre</button>
      <button (click)="aspectRat(4/3);" class="btn btnleft" type="button">4:3</button>
      <button (click)="aspectRat(16/9);" class="btn btnleft" type="button">16:9</button>      
      <button (click)="export(); modal.close();" class="btn btn-primary" type="button">Aplicar</button>
      <button (click)="modal.close()" [class.btn-outline-dark]="!darkTheme" [class.btn-outline-light]="darkTheme"
              class="btn"
              type="button">Cancelar
      </button>
    </div>
  </ng-template>
